<template>
  <div class="position-sticky" style="top: 65px; z-index: 1">
    <v-card variant="text">
      <v-card-text>
        <v-btn
          class="d-flex my-1"
          width="300"
          v-for="(category, i) in categoryStore.categoryData"
          :key="`catalog-category-${i}`"
          elevation="1"
          @click="goToCategory(category.code)"
          color="grey-darken-4"
          variant="flat"
          block
        >
          {{ category.descript ?? category.code }}
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { useTheme, useDisplay } from 'vuetify'
const { width, mobile } = useDisplay()

const categoryStore = useCategoryStore()
const searchStore = useSearchStore()

onMounted(async () => {
  console.log('> Left - onMounted')
  if (!categoryStore.categoryData) await categoryStore.getActiveCategory()
})

// computed

// method
const goToCategory = (categoryCode) => {
  if (searchStore.currentCategoryCode == categoryCode) return

  searchStore.initSearch() // for speed up when moving from large category to other category.
  //window.location.href = `/category/${g.urlEncode(categoryCode.toLowerCase())}`
  navigateTo({
    path: `/category/${g.urlEncode(categoryCode.toLowerCase())}`
    /*
    path: `/category/list`,
    query: {
      categoryCode
    }
    */
  })
}
</script>

<style scoped>
.v-list-group__items .v-list-item {
  padding-left: 20px !important;
}
</style>
